import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useStoreClientFromQuery = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const client = params.get('client');
    if (client) {
      localStorage.setItem('client', client);
    }
  }, [location]);
};

export default useStoreClientFromQuery;